/*
 * @Author: wangshengqiang
 * @Date: 2022-02-27 18:03:16
 * @LastEditTime: 2022-03-02 10:43:23
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React, { useEffect, useState } from 'react';
import { useStore } from '@/store';
import { Route, Router, Switch, withRouter } from 'react-router'; // import Form from '@/components';

import Gs from '@/Gs';
import { getQueryParam, getHashParam } from '@/utils';
import PageView from '../PageView'; // import PageViewOld from '../PageViewOld';

const GRouter = ({
  history
}) => {
  const configJson = useStore('configJson') || {};
  const {
    pageList = []
  } = configJson;
  const routes = [];

  if (pageList) {
    pageList.forEach(page => {
      routes.push( /*#__PURE__*/React.createElement(Route, {
        path: `/${page.pageOrder}`,
        key: page.pageId,
        component: () => /*#__PURE__*/React.createElement(PageView, {
          pageJson: page,
          key: page.pageId
        })
      }));
    });
  }

  if (Gs._routes) {
    Gs._routes.forEach(route => {
      routes.push( /*#__PURE__*/React.createElement(Route, {
        path: `${route.path}`,
        key: route.path,
        component: route.component
      }));
    });
  }

  const getCurrentPageJson = () => {
    const queryParam = getQueryParam();
    const num = getHashParam('page') || 1;
    const pageJson = pageList.find(pageItem => pageItem.pageId === queryParam.pageCode || pageItem.pageOrder == num);
    return pageJson || {};
  };

  return /*#__PURE__*/React.createElement(Router, {
    history: history
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/",
    component: () => /*#__PURE__*/React.createElement(PageView, {
      pageJson: getCurrentPageJson()
    })
  })));
};

export default GRouter;